import React from 'react'
import { Link } from "react-router-dom";


const HomeAbout = () => {
    return (
        <>
            <div className='page-wraper -bar-wrapper' style={{ overflow: "hidden", marginTop: "-110px" }}>
                <section className="about-one">
                    <div className="about-one_pattern" style={{ backgroundImage: 'url(assets/images/background/pattern-1.png)' }} />
                    <div className="auto-container">
                        <div className="row clearfix">
                            <div className="about-one_image-column col-lg-6 col-md-12 col-sm-12">
                                <div className="about-one_image-inner-column">
                                    <div className="about-one_icon">
                                        {/* <img src="assets/img/logo.png" alt style={{ width: "50px", height: "50px" }} /> */}
                                    </div>
                                    <div className="about-one_image">
                                        <img src="assets/img/10.jpeg" alt style={{ borderRadius: "10px" }} />
                                    </div>
                                    <div className="about-one_image-two">
                                        {/* <img src="assets/img/About Us.jpeg" alt /> */}
                                    </div>
                                </div>
                            </div>
                            <div className="about-one_content-column col-lg-6 col-md-12 col-sm-12">
                                <div className="about-one_content-inner-column">
                                    <div className="sec-title">
                                        <div className="sec-title_title">About Us</div>
                                        <h2 className="sec-title_heading">Welcome to Satna Swastik Hospital</h2>
                                        <div className="sec-title_text">At Satna Swastik Hospital, A connection based on accountability and trust is formed when you decide to trust the doctor. Physicians have an ethical and professional obligation to put their patients' health first, give them accurate information, and support them throughout their medical journey.</div>
                                        <div className="sec-title_text"> Located in Satna, Madhya Pradesh, Satna Swastik Hospital is a multidisciplinary super specialty hospital with 25+ beds. A group of committed medical professionals founded the hospital with the goal of offering top-notch medical care at a reasonable price. </div>
                                        {/* <div className="sec-title_text"> Over the past ten years, the hospital has demonstrated its ability to provide patients with the highest quality medical care. Thousands of patients have come to trust Satna Swastik Hospital throughout the years.</div> */}
                                        {/* <div className="sec-title_text"> The hospital and its staff of physicians, paramedics, and administrative personnel make every effort to treat and serve everyone. Unmatched in Central India, Satna Swastik Hospital boasts state-of-the-art technology and equipment. As a result, we all promise to provide the greatest services possible in every field. </div> */}
                                    </div>
                                    <div className="row clearfix">
                                        <div className="column col-lg-6 col-md-6 col-sm-12">
                                            <ul className="about-one_list">
                                                <li>Quality health care</li>
                                                <li>Only Qualified Doctors</li>
                                            </ul>
                                        </div>
                                        <div className="column col-lg-6 col-md-6 col-sm-12">
                                            <ul className="about-one_list">
                                                <li>Medical Research Professionals</li>
                                                <li>100% Expert Doctors</li>
                                            </ul>
                                        </div>
                                    </div>
                                    {/* Button Box */}
                                    <div className="about-one_button">
                                        <Link to="/about-us" className="theme-btn btn-style-one">
                                            <span className="btn-wrap" >
                                                <span className="text-one">View More</span>
                                                <span className="text-two">View More</span>
                                            </span>

                                        </Link>
                                        <br />
                                        <br />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>




        </>
    )
}

export default HomeAbout